module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "content-chapter",
    attrs: {
      "id": "calibre_toc_2"
    }
  }, [_c('a', {
    staticClass: "calibre3",
    attrs: {
      "id": "b1"
    }
  }), _c('a', {
    staticClass: "calibre3",
    attrs: {
      "href": "#/OEBPS/RealLifeOrg_split_002#a1"
    }
  }, [_vm._v("Foreword")]), _c('span', {
    staticClass: "normal-caps2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "b-head"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("Peter Walsh "), _c('br'), _vm._v("Bestselling Author")]), _c('span', {
    staticClass: "normal-caps3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Chances are you’re leafing through the pages of this book, wondering whether to buy it and wondering even more about how to successfully tackle that clutter you’re struggling with. "), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Everyone struggles with clutter to some degree, and all of us can use a little help with being more organized.  That’s where Cas Aarssen comes in!  Here in "), _c('em', {
    staticClass: "char-style-override3"
  }, [_vm._v("Real Life Organizing")]), _vm._v(" is a real solution to the clutter challenges we all face. A real solution from a real mom, and parent, and homeowner, and career person who knows what it is to struggle and to overcome disorganization in all its forms."), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', [_vm._v("I’ve worked for the past fifteen years helping people get their whole lives organized and I firmly believe that our homes are metaphors for our lives – they tell our story and show the world who we are. I believe it’s impossible to make your best choices, your most enlightened, spiritually rich, emotionally stable choices in a cluttered and disorganized home. It just can’t happen. Time and time again, I have seen how clutter hurts families and have witnessed firsthand, again and again, that when you declutter and open a space you create the opportunity for amazing things to flow into that space.")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('em', {
    staticClass: "char-style-override3"
  }, [_vm._v("Real Life Organizing")]), _vm._v(" leads you through the sometimes-difficult, always-rewarding path of decluttering your home.  By identifying your ‘clutter’ style’ you are helped to determine the best way forward.  This, combined with sensible and achievable tips and techniques, enables anyone to tackle clutter, organize spaces and find the peace and harmony that every family deserves."), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Stuff has power, and the stuff we own has power—power for good or power for ill. It’s up to each of us to decide how we use the stuff we own. Once again, this is where Cas steps in.  Not only does she help the reader understand the power of what they own, she also helps them to see their stuff as tools to help them create the life they want. The words “organization” and “organic” have the same root that means whole, complete, one. And that is the transformative power of organizing a home."), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('em', {
    staticClass: "char-style-override3"
  }, [_vm._v("Real Life Organizing")]), _vm._v(" is a reflection of so much of the wonderful work Cas does on her YouTube channel and elsewhere.  She demonstrates in these pages that organizing doesn’t have to be the impossible or overwhelming task that many think.  By establishing routines, implementing simple systems and making organization part of your daily life you can conquer clutter once and for all!"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Organization is not something you do, it’s the way you live your life. It is not about simply cleaning up, it is about making mindful decisions everyday about your life. "), _c('em', {
    staticClass: "char-style-override3"
  }, [_vm._v("Real Life Organizing")]), _vm._v(" will help with all that – and more!"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_4"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36f243d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/RealLifeOrg_split_004.vue
// module id = 69
// module chunks = 0